module.exports = __webpack_public_path__ + "img/mob1.d5728696.png";